import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { createUserCall, getOrganizations } from "api/api";
import Modal from "../../components/modal";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getIsSuperAdmin } from "../../helpers/checkPermission";

export default function CreateAdminForm({ open, onClose, reload }) {
  const [state, setState] = useState({
    name: "",
    userName: "",
    organizationId: null,
    organizations: [],
  });

  const isSuperAdmin = getIsSuperAdmin();
  const getAllOrganizations = async () => {
    const organizations = await getOrganizations();
    if (organizations) {
      setState({ ...state, organizations: organizations });
    }
  };

  useEffect(() => {
    if (isSuperAdmin && open) getAllOrganizations();
  }, [open]);

  const onCreate = async () => {
    if (isSuperAdmin && !state.organizationId) {
      return global.showAlert(
        "Validation Errors",
        "Organization is required to create a user",
        "warning"
      );
    }
    if (!state.name) {
      return global.showAlert("Validation Errors", "Name is required to create a user", "warning");
    }
    if (!state.userName) {
      return global.showAlert(
        "Validation Errors",
        "User Name is required to create a user",
        "warning"
      );
    }
    const response = await createUserCall({
      name: state.name,
      user_name: state.userName,
      organization_id: isSuperAdmin ? state.organizationId : undefined,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    setState({
      ...state,
      name: "",
      userName: "",
      organizationId: null,
    });
  }, [open]);

  return (
    <Modal
      title={"Add new user"}
      open={open}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onCreate} variant="gradient" color="info">
            submit
          </MDButton>
          <MDButton onClick={onClose} variant="gradient" color="error">
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        {isSuperAdmin && (
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel>Organization</InputLabel>
              <Select
                value={state?.organizationId}
                label="Organization"
                style={{
                  paddingBottom: "0.75rem",
                  paddingTop: "0.75rem",
                }}
                onChange={(event) => {
                  setState({ ...state, organizationId: event.target.value });
                }}
              >
                {state?.organizations?.map((org, index) => (
                  <MenuItem key={index} value={org.id}>
                    {org.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        )}

        <MDBox mb={2}>
          <MDInput
            type="string"
            label="Name"
            fullWidth
            value={state.name}
            onChange={(event) => {
              setState({ ...state, name: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="string"
            label="User Name"
            fullWidth
            value={state.userName}
            onChange={(event) => {
              setState({ ...state, userName: event.target.value.toLowerCase() });
            }}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
}
